import { DropdownItem } from "@/Common/Models/UI/Inputs/DropdownItem";
import { CodeValue } from "@/Patient/Components/MedicalItems/Immunization/Models/CodeValue";

export class ValueCodeDropdownItem extends DropdownItem<CodeValue> { }
